module.exports = __webpack_public_path__ + "static/img/news_top.3e729b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_top.png
// module id = HCCp
// module chunks = 1